import { TableCell, styled } from "@mui/material";

export const ASTableV2Cell = styled(TableCell)({
  display: "flex",
  alignItems: "center"
});
